import { render, staticRenderFns } from "./publishStatusStatis.vue?vue&type=template&id=066a0654&scoped=true&"
import script from "./publishStatusStatis.vue?vue&type=script&lang=js&"
export * from "./publishStatusStatis.vue?vue&type=script&lang=js&"
import style0 from "./publishStatusStatis.vue?vue&type=style&index=0&id=066a0654&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066a0654",
  null
  
)

export default component.exports